import React from 'react';
import { useTranslation } from 'react-i18next';

const useLoadingOverlay = (): string => {
  const { t } = useTranslation();
  const loadingTemplate: string = '<span class="ag-overlay-loading-center"><span class="spinner-border text-primary"></span></span>';

  return loadingTemplate;
};

export default useLoadingOverlay;
